const crypto = require('crypto');
const {EventBus} = require('./eventBus');
const uuid = () => crypto.randomBytes(16).toString('hex');
const moment = require('moment-timezone');
class TimeObserver{
  constructor(timeout){
    this.dates = [];
    setInterval(() => {
      this.updateDates();
      EventBus.$emit('time-update');
    },timeout)
  }
  add(date){
    this.dates.push(date);
  }
  remove(date){
    this.dates = this.dates.filter(d => d.id !== date.id);
  }
  updateDates(){
    this.dates.forEach(d => d.update());
  }
}
class TimeChild{
  constructor(observer,dates = []){
    this.observer = observer;
    this.id = uuid();
    this.dates = [...dates];
    this.timePassed = [];
    this.observer.add(this);
  }
  update(){
    this.timePassed = this.dates.map((date) => {
      const today = moment()
      let cdate = moment(date).utcOffset(-5);
      const seconds = today.diff(cdate,'seconds');
      return Math.abs(seconds.toFixed(0));
    })
  }
  remove(){
    this.observer.remove(this);
  }
  getTimes(){
    return this.timePassed;
  }
  setDates(dates){
    this.dates = [...dates];
  }
}
const timeObserver = new TimeObserver(30000);
module.exports = {
  timeObserver,
  TimeChild
}